import { render, staticRenderFns } from "./MemberExpandable.vue?vue&type=template&id=525f7fe5"
import script from "./MemberExpandable.vue?vue&type=script&lang=js"
export * from "./MemberExpandable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports